<template>
  <div>
    <WebHeaderView :title="$t('menu.task')" />
    <div class="page-content">
      <van-sticky :offset-top="46">
        <van-tabs
          @click="tabClick"
          v-model="active"
          color="#fff"
          title-active-color="#fff"
          style="margin-bottom: 10px"
        >
          <van-tab
            v-for="(item, index) in tasktype"
            :key="index"
            :title="item.name"
            :name="item.id"
          ></van-tab>
        </van-tabs>
      </van-sticky>
      <div style="height: calc(100vh - 2.6rem); overflow-y: auto">
        <UsrBoxView ref="usrbox" />
        <div v-for="(item, index) in tasklist" :key="index">
          <TaskItemView
            :item="item"
            @show-item="toShowTask"
            @refresh="refreshPage"
          />
        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      style="
        padding: 30px 15px 15px;
        border-radius: 8px;
        background-color: #282828;
      "
      :style="{ height: '60%', width: '80%' }"
      closeable
      round
    >
      <div
        style="
          margin-top: 30px;
          height: 38px;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
        "
        v-if="safeItem && safeItem.title"
      >
        {{ safeItem.title }}
      </div>
      <div
        style="
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          height: 38px;
          line-height: 38px;
          color: #cca352;
          margin: 10px 0;
        "
      >
        <p
          v-if="
            safeItem &&
            safeItem.progress.toString().length > 0 &&
            safeItem.status == 0
          "
        >
          进行中,已完成 {{ safeItem.progress }} %
        </p>
        <p v-else-if="safeItem && safeItem.status == 1">可领取</p>
        <p v-else-if="safeItem && safeItem.status == 2">已领取</p>
      </div>
      <div
        style="color: #fff"
        v-if="safeItem && safeItem.content"
        v-html="safeItem.content"
      ></div>
    </van-popup>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import { TaskItemView, UsrBoxView } from './components/index'
export default {
  name: 'TaskView',
  components: { WebHeaderView, TaskItemView, UsrBoxView },
  data () {
    return {
      active: -1,
      tasklist: [],
      forData: [],
      tasktype: [],
      show: false,
      safeItem: { progress: 0 }
    }
  },
  mounted () {
    this.GetTaskType()
  },
  methods: {
    refreshPage () {
      this.GetTaskType()
      this.$refs.usrbox.GetTimeVal()
      this.$refs.usrbox.GetUsrStats()
      this.$refs.usrbox.GetUsrBox()
    },
    toShowTask (item) {
      this.safeItem = item
      this.show = true
    },
    tabClick (val) {
      this.tasklist = []
      this.active = val
      this.GetUsrTask()
    },
    async GetTaskType () {
      await this.$http({
        method: 'get',
        url: 'taskType'
      }).then(res => {
        this.tasktype = res.data
        this.active = this.tasktype[0].id
        this.GetUsrTask()
      })
    },
    async GetUsrTask () {
      await this.$http({
        method: 'post',
        url: 'usrTask',
        data: { type_id: this.active }
      }).then(res => {
        this.tasklist = res.data
      })
    }
  }
}
</script>

<style></style>
